import React, { useEffect, useState } from 'react'
import { Dropdown } from 'tea-component'

import { PanelList, useConstant } from './constants'
import SelectPanel from './components/SelectPanel'
import CustomizedPanel from './components/CustomizedPanel'
import Result from './components/Result'
import Footer from './components/Footer'
import { TrackingDayProps } from './types'
import './dbTrackingDay.css';

const TrackingDay = (props: TrackingDayProps) => {
  const {
    value,
    panels = [PanelList.selectPanel, PanelList.customizedPanel],
    defaultValue,
    keyDaysValue = ['2'],
    maximumDays = 90,
    onChange,
    onSelectPanel,
    onCustomizedPanel
  } = props
  const { SELECT_LIST } = useConstant()
  const targetItemByValue = SELECT_LIST?.find(item => value?.includes(item.id)) ?? {id: value, name: value}
  const targetItemByDefaultValue = SELECT_LIST?.find(item => defaultValue?.includes(item.id)) ?? {id: defaultValue, name: defaultValue}
  const [activeItem, setActiveItem] = useState(panels[0] === PanelList.selectPanel ? SELECT_LIST[0] : {id: keyDaysValue[0], name: keyDaysValue[0]})
  const [activePanel, setActivePanel] = useState(panels[0])

  // searchPanel 的 input value
  const [inputValue, setInputValue] = useState('')
  const [isError, setIsError] = useState(false)

  // value 发生变化
  const handleChange = (activeItem, callback, error = isError) => {
    if (error || (inputValue === '' && activePanel === PanelList.customizedPanel)) return
    setActiveItem(activeItem)
    const result = (() => {
      if (activeItem.id === 'keyDays') return keyDaysValue

      const result: string[] = []
      if (activeItem?.id?.includes('-')) {
        const start = activeItem?.id?.split('-')[0]
        const end = activeItem?.id?.split('-')[1]

        for (let i = start; i <= end; i++) {
          result.push(String(i))
        }
      } else {
        result.push(activeItem.id)
      }
      return result
    })()
    onChange?.(result)
    callback?.()
  }

  // 选择变化事件
  const handleSelectChange = (activeItem, callback) => {
    handleChange(activeItem, callback, false)
    setInputValue('')
  }

  // 下拉面板变化事件
  const handlePanelChange = (activePanelId) => {
    if (activePanelId === PanelList.selectPanel) {
      onSelectPanel?.()
    } else {
      onCustomizedPanel?.()
    }
    setActivePanel(activePanelId)
  }

  // 处理自定义搜索的错误信息
  const handleError = (isError) => {
    setIsError(isError)
  }

  const handleOnClose = () => {
    // 延迟关闭提升用户体验，否则出现先闪到 selectPanel 再关闭的效果
    setTimeout(() => {
      setActivePanel(panels[0])
    }, 500)
  }

  useEffect(() => {
    if (SELECT_LIST[0].id === activeItem.id) {
      setActiveItem(SELECT_LIST[0])
    }
  }, [JSON.stringify(SELECT_LIST)])

  // useEffect(() => {
  //   let target: any = null
  //   if (targetItemByValue || targetItemByDefaultValue) {
  //     target = targetItemByValue ?? targetItemByDefaultValue
  //   }

  //   if (!target) return
  //   setActiveItem(target)
  // }, [value])

  return (
    <>
      <Dropdown
        className='dtb-db-tracking-day'
        button={<Result activeItem={activeItem}/>}
        size='m'
        appearance='button'
        // matchButtonWidth
        clickClose={false}
        onClose={handleOnClose}
      >
        {
          close => (
            <>
              {
                activePanel === PanelList.selectPanel ? (
                  <SelectPanel
                    close={close}
                    activeItem={activeItem}
                    onSelectChange={handleSelectChange}
                  />
                ) : (
                  <CustomizedPanel
                    cacheValue={inputValue}
                    isError={isError}
                    value={inputValue}
                    maximumDays={maximumDays}
                    onErrorChange={handleError}
                    onInputChange={setInputValue}
                  />
                )
              }
              <Footer
                close={close}
                isShowBack={panels?.includes(PanelList.selectPanel)}
                isError={isError}
                value={inputValue}
                activePanel={activePanel}
                onErrorChange={handleError}
                onPanelChange={handlePanelChange}
                onSelectChange={handleChange}
              />
            </>
          )
        }
      </Dropdown>
    </>
  )
}

export default TrackingDay
